import { _ as _slicedToArray } from '../unsorted/slicedToArray.js';
import { useState, useEffect } from 'react';

var imageUrlChecks = /(http|https|\/)/i;

/**
 * This function uses React hooks to detect if an image URL is valid or not.
 * @param {UseDetectBadImagePropTypes}  - The function `useDetectBadImage` takes in an object with a
 * single property `imageUrl`, which is a string representing the URL of an image. The object is of
 * type `UseDetectBadImagePropTypes`, which is not shown in the code snippet but is likely defined
 * elsewhere in the codebase.
 * @returns a boolean value indicating whether the provided image URL is valid or not. The validity of
 * the image is determined by attempting to load the image using an HTMLImageElement and checking if it
 * successfully loads or not. If the image loads successfully, the function returns true, otherwise it
 * returns false.
 */
function useDetectBadImage(_ref) {
  var imageUrl = _ref.imageUrl;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    imageIsValid = _useState2[0],
    setImageIsValid = _useState2[1];
  useEffect(function () {
    var image;
    var onLoad = function onLoad() {
      return setImageIsValid(true);
    };
    var onError = function onError() {
      return setImageIsValid(false);
    };
    if (imageUrl && imageUrlChecks.test(imageUrl)) {
      image = new Image();
      image.addEventListener("load", onLoad);
      image.addEventListener("error", onError);
      image.src = imageUrl;
    }
    return function () {
      var _image, _image2;
      (_image = image) === null || _image === void 0 ? void 0 : _image.removeEventListener("load", onLoad);
      (_image2 = image) === null || _image2 === void 0 ? void 0 : _image2.removeEventListener("error", onError);
    };
  }, [imageUrl]);
  return imageIsValid;
}

export { imageUrlChecks, useDetectBadImage };
//# sourceMappingURL=useDetectBadImage.js.map
